import { PageContext } from './index'

const page: PageContext = {
  widgets: [{
    id: 0,
    type: 'group_overview',
    title: null,
    active: true
  }],

  name: 'group-overview',
  url: '/group/overviewJS',
  breadcrumbs: [
    {
      phrase: ['Common', 'breadcrumb.homepage.text'],
      url: '/'
    },
    {
      phrase: ['Forum', 'groups'],
      url: './'
    }
  ]
}

export default page
